export default "__VITE_ASSET__bpH0Ygns__"